<template>

    <div class="sim">
	<div class="sim-ct">
		<ul>
			<li v-for="item in sun">
				<h5>{{item.title}}</h5>
				<p>{{item.num}} 產品</p>
			</li>
		
		</ul>
	</div>
  </div>
</template>
<script>
import index from "@/assets/bar/index.png";
import index_action from "@/assets/bar/index_action.png";
import serve from "@/assets/bar/serve.png";
import serve_action from "@/assets/bar/serve_action.png";
import user from "@/assets/bar/user.png";
import user_action from "@/assets/bar/user_action.png";
import notice from "@/assets/bar/notice.png";
import notice_action from "@/assets/bar/notice_action.png";
import act from "@/assets/bar/act.png";
import act_action from "@/assets/bar/act_action.png";


export default {
  data() {
    return {
		sun:'',
      barBtn: 0,
      barList: [
        {
          name: "首页",
          path: "/index/home",
          icon: index,
          icon_action: index_action,
        },
        {
          name: "服务",
          path: "/serve",
          icon: serve,
          icon_action: serve_action,
        }, {
          name: "政策公告",
          path: "/news",
          icon: notice,
          icon_action: notice_action,
        }, {
          name: "技能培训",
          path: "/act",
          icon: act,
          icon_action: act_action,
        },
        {
          name: "我的",
          path: "/user",
          icon: user,
          icon_action: user_action,
        },
      ],
    };
  },
  mounted() {
  	  
  
  		this.sandCase();
  		},
  methods: {
    getBarBtn(index) {
      this.barBtn = index;
    }, sandCase(){
			  	this.$axios({
			  	  method: "post",
			  	  url: "service.php?action=product_channelData",
			  	  data: {},  
			  	}).then((res) => {
			  		let data=res.data;
			  	
			  		if(data.code==1){
			  			this.sun=data.data;
			  		}
			  	 
			  	});
			  
			  }
  },
};
</script>

<style lang='scss' scoped>
.sim{
	background: #F9F9F9;
	height: 85px;
	padding-top: 40px;
	.sim-ct{
		width: 1200px;
		margin: 0 auto;
		
		
		ul{
			display: flex;
			justify-content: space-between;
			h5{
				font-size: 18px;
			}
			p{
				font-size: 14px;
			}
		}
	}
}
</style>